import { createBaseQuery } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'

const buttonApi = tokenSlice.injectEndpoints({
  reducerPath: 'button',
  baseQuery: createBaseQuery(),
  endpoints(builder) {
    return {
      getButton: builder.query({
        query: () => {
          return {
            url: 'Menu/GetUserMenusWithPrivileges',
            method: 'GET',
          }
        },
      }),
    }
  },
})

export const { useGetButtonQuery } = buttonApi
export { buttonApi }